// import TopNavigation from '../components/navigation/topNavigation.vue';
import TheNavigationBar from "../components/navigation/TheNavigationBar";
import FooterNavigation from "../components/footer/footer.vue";
import LogRocket from "logrocket";

export default {
  data() {
    return {
      isLandingModalShown: false,
    };
  },

  mounted() {
    try {
      this.isLandingModalShown = localStorage.getItem("IS_LANDING_MODAL_SHOWN");
    } catch (e) {
      this.$bugsnagClient.notify(new Error(e));
    }

    if (!this.isLandingModalShown) {
      this.$eventBus.$emit("show-landing-modal");
    }

    let user = JSON.parse(localStorage.getItem("USER_INFO"));

    if (user) {
      // Logrocket identify user with recording session
      LogRocket.identify(user.id, {
        name: user.email, // duplicated entry because there is no name related param in user info object
        email: user.email,
      });
    }
  },

  components: {
    TheNavigationBar,
    FooterNavigation,
  },
};
